module.exports = __webpack_public_path__ + "img/add-order.128a4dad.png";